/**
 * Lorinzer Living — Product Configurator v8
 * Fixed: addon radio watchers, summary price calculation, mattress state
 * Updated: headboard height variant support added
 */

(function () {
  'use strict';

  var ADDON_PRODUCTS = {
    ottoman_box : { handle: 'cubex-crushed-velvet-ottoman-box-storage-blanket-box-various-colors' },
    headboard   : { handle: 'vertical-split-headboard-option' },
    assembly    : { handle: 'assembly-service' }
  };

  var variantIdCache = {};

  function getVariantId(handle, callback) {
    if (variantIdCache[handle]) { callback(variantIdCache[handle]); return; }
    fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data && data.variants && data.variants[0]) {
          variantIdCache[handle] = data.variants[0].id;
          callback(data.variants[0].id);
        } else { callback(null); }
      })
      .catch(function() { callback(null); });
  }

  function prefetchVariantIds() {
    Object.keys(ADDON_PRODUCTS).forEach(function(key) {
      getVariantId(ADDON_PRODUCTS[key].handle, function() {});
    });
  }

  var state = {
    basePrice    : 0,
    variantLabels: {},
    colour       : '',
    fabric       : '',
    size         : ''
  };

  function money(pence) {
    return '\u00a3' + (pence / 100).toFixed(2);
  }

  /* ─── Read base price ─────────────────────────────────────────────────── */
  function readBasePrice() {
    var el = document.querySelector('hdt-price.hdt-price .hdt-money') ||
             document.querySelector('.hdt-price .hdt-money') ||
             document.querySelector('.hdt-money');
    if (!el) return;
    var text = el.textContent.replace(/[^0-9.]/g, '').trim();
    if (text) state.basePrice = Math.round(parseFloat(text) * 100) || 0;
  }

  /* ─── Get selected bed size ───────────────────────────────────────────── */
  function getSelectedSize() {
    if (state.size) return state.size;
    var allRadios = document.querySelectorAll('input[type="radio"]:checked');
    var foundSize = '';
    allRadios.forEach(function(r) {
      var val = r.value || '';
      if (val.toLowerCase().indexOf('ft') !== -1 &&
          val.toLowerCase().indexOf('storage') === -1 &&
          r.name !== 'llz_mattress_size') {
        foundSize = val;
      }
    });
    return foundSize;
  }

  /* ─── Fabric detection ────────────────────────────────────────────────── */
  function getFabricFromKalles() {
    var optionWrappers = document.querySelectorAll(
      '[class*="variant"] [class*="option"], [class*="swatch-group"], ' +
      '[data-option-index], .hdt-variant-picker > div, [class*="product-option"]'
    );
    var fabricValue = null;
    optionWrappers.forEach(function(wrapper) {
      if ((wrapper.textContent || '').toLowerCase().indexOf('fabric') !== -1) {
        var checked = wrapper.querySelector('input[type="radio"]:checked');
        if (checked) fabricValue = checked.value;
      }
    });
    return fabricValue;
  }

  /* ─── Watch variant changes ───────────────────────────────────────────── */
  function bindVariantWatchers() {
    document.addEventListener('change', function(e) {
      var input = e.target;
      if (!input || input.type !== 'radio') return;
      // Skip all our custom addon/mattress/headboard-height radios
      if (input.name && (
        input.name.indexOf('properties[') !== -1 ||
        input.name === 'llz_mattress_type' ||
        input.name === 'llz_mattress_size' ||
        input.name === 'llz_headboard_height'
      )) return;

      var value   = input.value;
      var optName = getOptionName(input);
      state.variantLabels[optName] = value;

      if (isSizeOption(value, optName)) state.size = value;
      if (isFabricOption(input, optName, value)) {
        state.fabric = value;
        document.dispatchEvent(new CustomEvent('llz:fabric-changed', { detail: { fabric: value } }));
      }

      setTimeout(function() {
        readBasePrice();
        window.LLZ_updateSummary && window.LLZ_updateSummary();
      }, 200);
    });

    document.addEventListener('variant:change', function(e) {
      if (e.detail && e.detail.variant) {
        state.basePrice = e.detail.variant.price || 0;
        window.LLZ_updateSummary && window.LLZ_updateSummary();
      }
    });

    document.addEventListener('hdt:variant:change', function(e) {
      if (e.detail && e.detail.variant) {
        state.basePrice = e.detail.variant.price || 0;
        window.LLZ_updateSummary && window.LLZ_updateSummary();
      }
    });

    document.addEventListener('click', function(e) {
      var variantLabel = e.target.closest('[class*="swatch"], [class*="variant-btn"], [class*="option-btn"]');
      if (!variantLabel) return;
      setTimeout(function() {
        var fabricVal = getFabricFromKalles();
        if (fabricVal && fabricVal !== state.fabric) {
          state.fabric = fabricVal;
          document.dispatchEvent(new CustomEvent('llz:fabric-changed', { detail: { fabric: fabricVal } }));
        }
        readBasePrice();
        window.LLZ_updateSummary && window.LLZ_updateSummary();
      }, 100);
    });

    // Seed initial state
    document.querySelectorAll('input[type="radio"]:checked').forEach(function(input) {
      if (!input.name) return;
      if (input.name.indexOf('properties[') !== -1) return;
      if (input.name === 'llz_mattress_type' || input.name === 'llz_mattress_size') return;
      if (input.name === 'llz_headboard_height') return;
      var value   = input.value;
      var optName = getOptionName(input);
      state.variantLabels[optName] = value;
      if (isSizeOption(value, optName)) state.size = value;
      if (isFabricOption(input, optName, value)) state.fabric = value;
    });
  }

  function getOptionName(input) {
    var parent = input.closest('[data-option-name]');
    if (parent) return parent.getAttribute('data-option-name');
    var wrapper = input.closest('fieldset, [class*="option"], [class*="swatch-group"], div');
    if (wrapper) {
      var legend = wrapper.querySelector('legend, [class*="label"], [class*="title"], [class*="heading"]');
      if (legend) { var t = legend.textContent.replace(/:.*/,'').trim(); if (t) return t; }
    }
    return input.name || 'Option';
  }

  function isSizeOption(value, optName) {
    if (optName && optName.toLowerCase().indexOf('size') !== -1) return true;
    var v = value.toLowerCase();
    return v.indexOf('ft') !== -1 && v.indexOf('storage') === -1;
  }

  function isFabricOption(input, optName, value) {
    if (optName.toLowerCase().indexOf('fabric') !== -1) return true;
    var fabricNames = ['linen fabric','bouclé/teddy','boucle/teddy','soft naple velvet','plush/suede fabric','chenille fabric'];
    if (fabricNames.indexOf(value.toLowerCase()) !== -1) return true;
    var wrapper = input.closest('fieldset, [class*="option-group"], div');
    if (wrapper) {
      var text = wrapper.textContent.toLowerCase();
      if (text.indexOf('choose fabric') !== -1 || text.indexOf('fabric:') !== -1) return true;
    }
    return false;
  }

  /* ─── Watch addon card radio changes ─────────────────────────────────────
     Only watches properties[] radios (our custom addon inputs)           */
  function bindAddonWatchers() {
    document.addEventListener('change', function(e) {
      var input = e.target;
      if (!input || input.type !== 'radio') return;
      if (!input.name || input.name.indexOf('properties[') === -1) return;

      // Find parent addon row
      var row = input.closest('[data-addon]');
      if (!row) return;

      // Update card selected state
      row.querySelectorAll('.llz-addon-card').forEach(function(card) {
        card.classList.toggle('is-selected', card.contains(input) && input.checked);
      });

      window.LLZ_updateSummary && window.LLZ_updateSummary();
    });
  }

  function bindColourWatcher() {
    document.addEventListener('llz:colour-changed', function (e) {
      state.colour = e.detail.colour;
      window.LLZ_updateSummary && window.LLZ_updateSummary();
    });
  }

  /* ─── Get mattress state ─────────────────────────────────────────────── */
  function getMattressState() {
    var mattressRadio = document.querySelector('input[name="properties[Mattress]"]:checked');
    var isYes = mattressRadio && mattressRadio.value.toLowerCase().indexOf('yes') !== -1;

    if (!isYes) return { isYes: false, variantId: null, price: 0, typeLabel: '', sizeLabel: '' };

    var vidEl   = document.getElementById('llz-mattress-variant-id');
    var priceEl = document.getElementById('llz-mattress-price-pence');
    var typeEl  = document.getElementById('llz-mattress-type-prop');
    var sizeEl  = document.getElementById('llz-mattress-size-prop');

    return {
      isYes     : true,
      variantId : vidEl   ? parseInt(vidEl.value, 10)   : null,
      price     : priceEl ? parseInt(priceEl.value, 10) : 0,
      typeLabel : typeEl  ? typeEl.value  : '',
      sizeLabel : sizeEl  ? sizeEl.value  : ''
    };
  }

  /* ─── Get headboard height state ─────────────────────────────────────── */
  function getHeadboardHeightState() {
    var input = document.querySelector('input[name="llz_headboard_height"]:checked');
    if (!input) return { isCustom: false, label: '54 inches', extra: 0 };
    var val   = input.value;
    var match = val.match(/(\d+) inches tall.+\(\+£(\d+)\)/);
    if (!match) return { isCustom: false, label: '54 inches', extra: 0 };
    return {
      isCustom : true,
      label    : match[1] + ' inches tall',
      extra    : parseInt(match[2], 10) * 100
    };
  }

  /* ─── Helper: is addon Yes? ──────────────────────────────────────────── */
  function isAddonYes(propName) {
    var el = document.querySelector('input[name="properties[' + propName + ']"]:checked');
    return el && el.value.toLowerCase().indexOf('yes') !== -1;
  }

  function getAddonPrice(addonDataAttr) {
    var row = document.querySelector('[data-addon="' + addonDataAttr + '"]');
    return row ? parseInt(row.getAttribute('data-addon-price'), 10) || 0 : 0;
  }

  /* ─── Summary update ─────────────────────────────────────────────────── */
  window.LLZ_updateSummary = function () {
    var SUMMARY_ROWS  = document.getElementById('llz-summary-rows');
    var SUMMARY_TOTAL = document.getElementById('llz-summary-total');
    if (!SUMMARY_ROWS || !SUMMARY_TOTAL) return;

    var rows  = '';
    var total = state.basePrice;

    // Variant selections (size, ottoman, fabric)
    Object.keys(state.variantLabels).forEach(function (optName) {
      var val = state.variantLabels[optName];
      if (val) {
        rows += '<div class="llz-summary-row">' +
                  '<span class="llz-summary-row-label">' + optName + '</span>' +
                  '<span class="llz-summary-row-value">' + val + '</span>' +
                '</div>';
      }
    });

    // Colour
    if (state.colour) {
      rows += '<div class="llz-summary-row">' +
                '<span class="llz-summary-row-label">Colour</span>' +
                '<span class="llz-summary-row-value">' + state.colour + '</span>' +
              '</div>';
    }

    // Ottoman Storage Box
    var ottomanYes = isAddonYes('Ottoman Storage Box');
    var ottomanPrice = getAddonPrice('ottoman_box');
    if (ottomanYes) total += ottomanPrice;
    rows += '<div class="llz-summary-row">' +
              '<span class="llz-summary-row-label">Ottoman Storage Box</span>' +
              '<span class="llz-summary-row-value">' +
              (ottomanYes ? '<span class="llz-summary-yes">+ ' + money(ottomanPrice) + '</span>'
                          : '<span class="llz-summary-no">Not added</span>') +
              '</span></div>';

    // Mattress
    var m = getMattressState();
    if (m.isYes) {
      total += m.price;
      rows += '<div class="llz-summary-row">' +
                '<span class="llz-summary-row-label">' + m.sizeLabel + ' Mattress</span>' +
                '<span class="llz-summary-row-value llz-summary-yes">+ ' + money(m.price) + '</span>' +
              '</div>';
      if (m.typeLabel) {
        rows += '<div class="llz-summary-row">' +
                  '<span class="llz-summary-row-label" style="font-size:10px;opacity:0.65">' + m.typeLabel + '</span>' +
                  '<span class="llz-summary-row-value"></span>' +
                '</div>';
      }
    } else {
      rows += '<div class="llz-summary-row">' +
                '<span class="llz-summary-row-label">Mattress</span>' +
                '<span class="llz-summary-row-value llz-summary-no">Not added</span>' +
              '</div>';
    }

    // Headboard Height — only show if the UI block is present on this product
    var hhRow = document.querySelector('[data-addon="headboard_height"]');
    if (hhRow) {
      var hh = getHeadboardHeightState();
      if (hh.isCustom && hh.extra > 0) total += hh.extra;
      rows += '<div class="llz-summary-row">' +
                '<span class="llz-summary-row-label">Headboard Height</span>' +
                '<span class="llz-summary-row-value">' +
                hh.label +
                (hh.isCustom && hh.extra > 0
                  ? ' <span class="llz-summary-yes">+ ' + money(hh.extra) + '</span>'
                  : '') +
                '</span></div>';
    }

    // Split Headboard
    var headboardYes   = isAddonYes('Split Headboard');
    var headboardPrice = getAddonPrice('headboard');
    if (headboardYes) total += headboardPrice;
    rows += '<div class="llz-summary-row">' +
              '<span class="llz-summary-row-label">Split Headboard</span>' +
              '<span class="llz-summary-row-value">' +
              (headboardYes ? '<span class="llz-summary-yes">+ ' + money(headboardPrice) + '</span>'
                            : '<span class="llz-summary-no">Not added</span>') +
              '</span></div>';

    // Assembly Service
    var assemblyYes   = isAddonYes('Assembly Service');
    var assemblyPrice = getAddonPrice('assembly');
    if (assemblyYes) total += assemblyPrice;
    rows += '<div class="llz-summary-row">' +
              '<span class="llz-summary-row-label">Assembly Service</span>' +
              '<span class="llz-summary-row-value">' +
              (assemblyYes ? '<span class="llz-summary-yes">+ ' + money(assemblyPrice) + '</span>'
                           : '<span class="llz-summary-no">Not added</span>') +
              '</span></div>';

    SUMMARY_ROWS.innerHTML = rows ||
      '<div class="llz-summary-row llz-summary-placeholder"><span>Select your options above</span></div>';
    SUMMARY_TOTAL.textContent = money(total);
  };

  /* ─── Cart injection ─────────────────────────────────────────────────── */
  var cartSubmitting = false;

  function bindCartInjection() {
    var form = document.querySelector('form[action="/cart/add"]');
    if (!form) return;

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      if (cartSubmitting) return;
      cartSubmitting = true;

      var btn = form.querySelector('button[type="submit"], button.hdt-product-form__submit');
      if (btn) { btn.disabled = true; btn.style.opacity = '0.6'; }

      // Get bed variant ID
      var variantInput = form.querySelector('input[name="id"]');
      var bedVariantId = variantInput ? parseInt(variantInput.value, 10) : null;
      if (!bedVariantId) { form.submit(); return; }

      // Collect bed properties (exclude addon properties)
      var bedProperties = {};
      var formData = new FormData(form);
      formData.forEach(function(value, key) {
        if (key.indexOf('properties[') === -1) return;
        var propName = key.replace('properties[', '').replace(']', '');
        // Skip addon props — they go on their own line items
        var skip = ['Mattress','Ottoman Storage Box','Split Headboard','Assembly Service',
                    'Mattress Type','Mattress Size'];
        if (skip.indexOf(propName) !== -1) return;
        bedProperties[propName] = value;
      });

      // Build items array — bed first
      var items = [{ id: bedVariantId, quantity: 1, properties: bedProperties }];

      // Promises for variant ID lookups
      var promises = [];

      // Ottoman
      if (isAddonYes('Ottoman Storage Box')) {
        promises.push(new Promise(function(resolve) {
          getVariantId(ADDON_PRODUCTS.ottoman_box.handle, function(vid) {
            if (vid) items.push({ id: vid, quantity: 1, properties: {} });
            resolve();
          });
        }));
      }

      // Mattress — use direct variant ID
      var m = getMattressState();
      if (m.isYes && m.variantId) {
        items.push({
          id        : m.variantId,
          quantity  : 1,
          properties: { 'Type': m.typeLabel, 'Size': m.sizeLabel }
        });
      }

      // Headboard
      if (isAddonYes('Split Headboard')) {
        promises.push(new Promise(function(resolve) {
          getVariantId(ADDON_PRODUCTS.headboard.handle, function(vid) {
            if (vid) items.push({ id: vid, quantity: 1, properties: {} });
            resolve();
          });
        }));
      }

      // Assembly
      if (isAddonYes('Assembly Service')) {
        promises.push(new Promise(function(resolve) {
          getVariantId(ADDON_PRODUCTS.assembly.handle, function(vid) {
            if (vid) items.push({ id: vid, quantity: 1, properties: {} });
            resolve();
          });
        }));
      }

      Promise.all(promises).then(function() {
        fetch('/cart/add.js', {
          method : 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body   : JSON.stringify({ items: items })
        })
        .then(function() { window.location.href = '/cart'; })
        .catch(function(err) {
          console.error('Cart error:', err);
          cartSubmitting = false;
          if (btn) { btn.disabled = false; btn.style.opacity = '1'; }
        });
      });

    }, true);
  }

  /* ─── Init ────────────────────────────────────────────────────────────── */
  function init() {
    prefetchVariantIds();
    readBasePrice();
    bindVariantWatchers();
    bindAddonWatchers();
    bindColourWatcher();
    bindCartInjection();
    window.LLZ_updateSummary();

    setTimeout(function() {
      var fabricVal = getFabricFromKalles();
      if (fabricVal) {
        state.fabric = fabricVal;
        document.dispatchEvent(new CustomEvent('llz:fabric-changed', { detail: { fabric: fabricVal } }));
      }
      readBasePrice();
      window.LLZ_updateSummary();
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 100);
  }

})();
